import { render, staticRenderFns } from "./AffiliateCustomerView.vue?vue&type=template&id=4825829b&"
import script from "./AffiliateCustomerView.vue?vue&type=script&lang=js&"
export * from "./AffiliateCustomerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports